import React, { useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import SpinnerLoading from "../../Common/SpinnerLoading";

const DocumentsTable = ({
   isLoading,
   setIsLoading,
   search,
   setSearch,
   pagination,
   setPagination,
   selectedItems,
   setSelectedItems,
   documents,
   setDocumentNumber,
   setUpdate,
}) => {
   const { t: translator } = useTranslation();
   const history = useHistory();
   const { isMobile } = useContext(GlobalContext);

   const handleTableChange = (type, { page, sizePerPage }) => {
      setIsLoading(true);
      setPagination({
         ...pagination,
         pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
         pageSize: sizePerPage,
      });
      setUpdate(new Date());
   };

   const handleOnSelect = (row, isSelect) => {
      console.log("select", row.documentNumber);
      setDocumentNumber(row.documentNumber);
      if (isSelect) {
         setSelectedItems([...selectedItems, row.documentId]);
      } else {
         setSelectedItems(selectedItems.filter((p) => p !== row.documentId));
      }
   };

   function actionFormatter(cell, row) {
      return (
         <div className="action">
            <label className="labelCont">
               <input
                  type="checkbox"
                  checked={selectedItems.find((x) => x === row.documentId)}
                  onChange={(e) => handleOnSelect(row, e.target.checked)}
               />
               <span className="checkmark"></span>
            </label>
         </div>
      );
   }

   function actionHeaderFormatter(cell, rows) {
      return (
         <div className="action">
            <label className="labelCont">
               <input
                  type="checkbox"
                  checked={
                     documents &&
                     documents.length > 0 &&
                     !documents
                        .map((p) => p.documentId)
                        .some((p) => selectedItems.indexOf(p) < 0)
                  }
                  onChange={(e) => handleOnSelectAll(e.target.checked)}
               />
               <span className="checkmark"></span>
            </label>
         </div>
      );
   }
   function dateTimeFormatter(cell, row) {
      return new Intl.DateTimeFormat("hr", {
         year: "numeric",
         month: "numeric",
         day: "numeric",
      }).format(new Date(cell));
   }

   const sorting = (sortName) => {
      setSearch({ ...search, sortName, isAsc: !search.isAsc });
   };

   const handleOnSelectAll = (isSelect) => {
      if (isSelect) {
         setSelectedItems(documents.map((x) => x.documentId));
      } else {
         setSelectedItems([]);
      }
   };

   const rowEvents = {
      onClick: (e, row, rowIndex) => {
         if (e.target.cellIndex) {
            history.push(`/handover-details/${row.documentId}`);
         }
      },
   };

   const columns = [
      {
         dataField: "documentId",
         text: "",
         headerStyle: (colum, colIndex) => {
            return { width: "50px", textAlign: "center" };
         },
         headerFormatter: actionHeaderFormatter,
         formatter: actionFormatter,
      },
      {
         dataField: "date",
         text: translator("InitialState-TableHeader-Date"),
         headerEvents: { onClick: () => sorting("DocumentDate") },
         formatter: dateTimeFormatter,
         sort: true,
         sortCaret: (order, column) => {
            if (search.sortName !== "DocumentDate")
               return <i className="fa fa-fw fa-sort"></i>;
            if (search.sortName === "DocumentDate") {
               return search.isAsc !== true ? (
                  <i className="fa fa-fw fa-sort-up"></i>
               ) : (
                  <i className="fa fa-fw fa-sort-down"></i>
               );
            }
         },
      },
      {
         dataField: "storeName",
         text: translator("InitialState-StoreName"),
         hidden: Boolean(isMobile),
      },
      {
         dataField: "documentNumber",
         text: translator("InitialState-TableHeader-DocumentNumber"),
         headerEvents: { onClick: () => sorting("DocumentNumber") },
         sort: true,
         sortCaret: (order, column) => {
            if (search.sortName !== "DocumentNumber")
               return <i className="fa fa-fw fa-sort"></i>;
            if (search.sortName === "DocumentNumber") {
               return search.isAsc !== true ? (
                  <i className="fa fa-fw fa-sort-up"></i>
               ) : (
                  <i className="fa fa-fw fa-sort-down"></i>
               );
            }
         },
      },
      {
         dataField: "note",
         text: translator("InitialState-TableHeader-Note"),
         hidden: Boolean(isMobile),
      },
   ];

   const RemoteAll = ({
      data,
      page,
      sizePerPage,
      totalSize,
      onTableChange,
   }) => (
      <div>
         <BootstrapTable
            remote
            keyField="documentId"
            rowEvents={rowEvents}
            data={data}
            columns={columns}
            rowClasses="boostrap-table-row"
            noDataIndication={translator("No-Data")}
            pagination={paginationFactory({
               page,
               sizePerPage,
               totalSize,
            })}
            onTableChange={onTableChange}
         />
      </div>
   );
   return isLoading ? (
      <div className="dashboard-card-spinner">
         <SpinnerLoading />
      </div>
   ) : (
      <RemoteAll
         data={documents}
         page={pagination.pageIndex + 1}
         sizePerPage={pagination.pageSize}
         totalSize={pagination.totalCount}
         onTableChange={handleTableChange}
      />
   );
};

export default DocumentsTable;
